const colors = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#FED766', '#2AB7CA',
  '#F0B37E', '#F9ADA0', '#8A9B0F', '#A23B72', '#34568B',
  '#F76C6C', '#5B5F97', '#FFC154', '#474747', '#E6E6FA',
  '#FFD6A5', '#C9CBA3', '#FFE1A8', '#E26D5C', '#723D46',
  '#472D30', '#B79D94', '#9A8C98', '#4A4E69', '#22223B',
  '#C19AB7'
];

export const getColorForLetter = (letter) => {
  const charCode = letter.toUpperCase().charCodeAt(0);
  // Basic check for A-Z
  if (charCode >= 65 && charCode <= 90) {
    return colors[charCode - 65];
  }
  // Fallback for other characters
  return '#808080'; // Grey
};
